module.exports = __webpack_public_path__ + "static/media/printhub_logo.50470788.svg";